import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {BrickSnake2000} from "../../BrickSnake2000";
import {gsap} from "gsap";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {FreespinBlockerSymbol} from "../../reels/symbols/FreespinBlockerSymbol";

/**
 * Created by jonas on 2022-09-02.
 */

export class FreeSpinUpgrade implements SimplePresentation {

    name:string = "FreeSpinUpgrade";

    constructor() {

    }

    public shouldRun():boolean {
        return !BrickSnake2000.model.data.brokeTheBank &&
            BrickSnake2000.model.data.mode == GameMode.FREESPIN &&
            (BrickSnake2000.model.data.nextMode == GameMode.FREESPIN_SUPER);
    }

    public start(controller:SimplePresentationRunnerController):void {
        const tl = gsap.timeline();
        BrickSnake2000.autoPlayPlugin.turnOffAutoplayOnBonus();

        tl.add(<any>BrickSnake2000.keypadPlugin.hide(0.1),0);
        tl.add(BrickSnake2000.transitionScreen.showUpgrade(), '<');
        tl.add(() => {BrickSnake2000.soundPlayer.playSound("introOneShot")}, '<');
        tl.add(() => {BrickSnake2000.soundPlayer.playLoopingSound("sfsIntroLoop")}, '<');
        tl.add(() => BrickSnake2000.soundPlayer.fadeOutMusic(), '<');
        tl.add(BrickSnake2000.transitionScreen.enableButton(() => this.onButtonClick(controller)), '<0.1');
    }

    private onButtonClick(controller:SimplePresentationRunnerController) {
        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            BrickSnake2000.keypadPlugin.setZeroBetSpinCounter(-1);
            BrickSnake2000.keypadPlugin.show(0.1);
        });
        tl.add(BrickSnake2000.backgroundElements.setToSuperFreespins());
        tl.add(BrickSnake2000.transitionScreen.hideUpgrade(), '<');
        tl.add(() => {
            FreespinBlockerSymbol.forceSFSBlockers = true;
            BrickSnake2000.freespinsReelView.upgradeReelsToSFS();
            BrickSnake2000.freespinsReelView.enableCollectorDisplay();
            BrickSnake2000.soundPlayer.stopSound("sfsIntroLoop");
            BrickSnake2000.soundPlayer.switchMusic(GameMode.FREESPIN_SUPER)
        }, '<')
        tl.add(() => BrickSnake2000.soundPlayer.fadeInMusic(), '<');
        tl.add(() => controller.finish());

    }
}